import { useEffect, useState } from 'react';
import { Theme } from '@streem/ui-react';
export const useMediaBreakpoint = () => {
    const [isSmallScreen, setIsSmallScreenState] = useState(() => window.matchMedia(Theme.mediaBreakpoints.small).matches);
    const [isMobile, setIsMobileState] = useState(() => window.matchMedia(Theme.mediaBreakpoints.xsmall).matches);
    useEffect(() => {
        const smallBreakpoint = window.matchMedia(Theme.mediaBreakpoints.small);
        const xsmallBreakpoint = window.matchMedia(Theme.mediaBreakpoints.xsmall);
        const handleSmallScreenChange = (e) => setIsSmallScreenState(e.matches);
        const handleMobileChange = (e) => {
            setIsMobileState(e.matches);
        };
        smallBreakpoint.addEventListener('change', handleSmallScreenChange);
        xsmallBreakpoint.addEventListener('change', handleMobileChange);
        return () => {
            smallBreakpoint.removeEventListener('change', handleSmallScreenChange);
            xsmallBreakpoint.removeEventListener('change', handleMobileChange);
        };
    }, []);
    return {
        isSmallScreen,
        isMobile,
    };
};
//# sourceMappingURL=use_media_breakpoint.js.map